// project imports
import config from 'config'; // Importing global configuration (e.g., font, border radius)
// action - state management
import * as actionTypes from './actions'; // Importing action type constants

// Initial state for the customization reducer
export const initialState = {
    isOpen: [], // Tracks which menu(s) are currently open
    fontFamily: config.fontFamily, // Default font family from config
    borderRadius: config.borderRadius, // Default border radius from config
    opened: true, // Used to determine if the sidebar/menu is opened
    userDetail: [] // Stores user details
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
    let id;

    switch (action.type) {
        case actionTypes.MENU_OPEN:
            // Triggered when a menu is opened
            id = action.id;
            return {
                ...state,
                isOpen: [id] // Update open menu ID
            };

        case actionTypes.SET_MENU:
            // Toggles the menu/sidebar open or closed
            return {
                ...state,
                opened: action.opened
            };

        case actionTypes.SET_MENU2:
            // Same functionality as SET_MENU (can be refactored later if needed)
            return {
                ...state,
                opened: action.opened
            };

        case actionTypes.SET_FONT_FAMILY:
            // Updates the font family setting
            return {
                ...state,
                fontFamily: action.fontFamily
            };

        case actionTypes.SET_BORDER_RADIUS:
            // Updates the border radius setting
            return {
                ...state,
                borderRadius: action.borderRadius
            };

        case actionTypes.USER_DETAILS:
            // Stores or updates the user details
            return {
                ...state,
                userDetail: action.userDetail
            };

        default:
            // Return current state for any unknown actions
            return state;
    }
};

export default customizationReducer; // Exporting reducer as default
